import { takeLatest, call, put, select } from 'redux-saga/effects';
import _ from 'lodash';
import axios from '../axiosConfig';
import {
  getTripRequest,
  getTripSuccess,
  getTripFailure,
  setTripConfirmation,
} from '../../slices/trip';
import { setArchRoamAgentId } from '../../slices/user';
import { priceRequestTakeLatest } from '../../slices/cruise';
import { setCruiseSearchInputs, setCruiseSearchParam } from '../../slices/tripSearch';
import getFiltersFromTrip from '../../../helpers/getFiltersFromTrip';
import formatPriceRequest from '../../../helpers/formatPriceRequest';
import { TravelTypes } from '../../../constants';

function* getTripWorker({ payload: { tripId, isTripQuote, isBrochure, isDedicatedHotelTrip } }) {
  try {
    let url = '/trips/checkout';
    if (isTripQuote) url = '/trips/checkout/tripquote';
    else if (isBrochure) url = '/trips/checkout/brochure';
    else if (isDedicatedHotelTrip) url = '/trips/checkout/dedicatedHotel';

    const config = {
      method: 'post',
      url,
      data: {
        tripId,
      },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    const { data } = yield call(axios, config);

    if (data && data.trip) {
      const searchObj = {
        filters: getFiltersFromTrip(data.trip),
        staterooms: getFiltersFromTrip(data.trip).staterooms,
      };
      yield put(setCruiseSearchParam(searchObj));
      yield put(setCruiseSearchInputs(searchObj));

      yield put(
        getTripSuccess({
          tripId,
          trip: {
            ...(data.trip || {}),
            maxCharsNoteToAirDesk: data.maxCharsNoteToAirDesk,
            doShowNoteToAirDeskInput: data.doShowNoteToAirDeskInput,
            doShowCompanyNameInput: data.doShowCompanyNameInput,
            doShowAgencyPlanningFeesPerPassenger: data.doShowAgencyPlanningFeesPerPassenger,
            separatePnrForTravelTypes: data.separatePnrForTravelTypes,
            doSupportsCardUpsertOperations: data.doSupportsCardUpsertOperations,
            tripBookingFees: data.tripBookingFees,
          },
          tripConfirmation: data.tripConfirmation,
        }),
      );

      if (data.archRoamAgentId) {
        yield put(setArchRoamAgentId(data.archRoamAgentId));
      }

      if (data.tripConfirmation) {
        const { travelAgency } = yield select((store) => store.user);
        yield put(
          setTripConfirmation({
            tripConfirmation: data.tripConfirmation,
            isUpdatingBookedTrip: (data.trip && data.trip.isUpdatingBookedTrip) || false,
            travelAgency,
          }),
        );
        const cruiseItinerary = _.find(
          data.tripConfirmation.trip.tripSegments,
          (ts) => ts.mode === TravelTypes.cruise,
        );
        if (cruiseItinerary && cruiseItinerary.itinerary) {
          yield put(
            priceRequestTakeLatest(
              formatPriceRequest({
                itinerary: cruiseItinerary.itinerary,
                passengers: data.tripConfirmation.travelers,
                bookingResponses: data.tripConfirmation.bookingResponses,
              }),
            ),
          );
        }
      }
    } else {
      yield put(getTripFailure('Trip not found!'));
    }
  } catch (error) {
    yield put(getTripFailure(`${error.response.data.title} ${error.response.data.detail}`));
  }
}

function* getTripWatcher() {
  yield takeLatest(getTripRequest.toString(), getTripWorker);
}

export default getTripWatcher;
